export function normalizeIsraeliPhone(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  // ponytail: mirrors functions/payslips teamLinkWorkerByPhone normalization (972/0/local only)
  if (digits.startsWith('00972')) return '+972' + digits.slice(5);
  if (digits.startsWith('972')) return '+' + digits;
  if (digits.startsWith('0')) return '+972' + digits.slice(1);
  return '+972' + digits;
}
